import { DataSourceSort } from 'custom_hooks/data_hooks/data_source/data_source';
import { SortField, SortState } from 'pages/Corporation/issues/utils';
import { createStorageUtils } from 'shared/storage/createStorageUtils';
import {
    isValidDataSourceSort,
    isValidSortArray,
    isValidSortDirection,
} from 'shared/storage/validation';
import { isObjectValid, ObjectConstraints, valueInList } from 'utils/object-validation';

export type StoredCorporationOverviewState = Readonly<{
    favoritesFilter: 'favorites' | undefined;
    issuesWidgetSort: SortState;
    assetsWithAlertsSort: DataSourceSort[];
}>;

const ValidIssueSortFields: SortField[] = [
    'locationName',
    'newIssueCount',
    'openIssueCount',
    'averageDaysIssueOpened',
    'downtimeHoursSaved',
    'totalSavings',
];

export const DefaultCorporationOverviewState: StoredCorporationOverviewState = {
    favoritesFilter: undefined,
    issuesWidgetSort: { field: 'newIssueCount', direction: 'desc' },
    assetsWithAlertsSort: [{ field: 'TotalAssetsInCriticalAlarmCount', dir: 'desc' }],
};

const isValidIssueSortField = (value: unknown) =>
    valueInList(value, ValidIssueSortFields);

const isValidFavoritesFilter = (value: unknown): value is 'favorites' | undefined =>
    value === 'favorites' || value === undefined;

const IssuesWidgetSortConstraints: ObjectConstraints<SortState> = {
    field: isValidIssueSortField,
    direction: isValidSortDirection,
};

const isValidIssuesWidgetSort = (value: unknown): value is SortState =>
    isObjectValid(value, IssuesWidgetSortConstraints);

const CorporationOverviewStateConstraints: ObjectConstraints<StoredCorporationOverviewState> = {
    favoritesFilter: isValidFavoritesFilter,
    issuesWidgetSort: isValidIssuesWidgetSort,
    assetsWithAlertsSort: isValidSortArray,
};

const corporationOverviewStorage = createStorageUtils<StoredCorporationOverviewState>({
    baseKey: 'corporation-overview.state.storage',
    constraints: CorporationOverviewStateConstraints,
    defaults: DefaultCorporationOverviewState,
});

export const getCorporationOverviewStorageKey = corporationOverviewStorage.getStorageKey;
export const loadCorporationOverviewState = corporationOverviewStorage.load;
export const saveCorporationOverviewState = corporationOverviewStorage.save;
export const clearCorporationOverviewState = corporationOverviewStorage.clear;

export { isValidDataSourceSort };
